// import { UserInfoModel } from "@/core/Account/model/UserInfoModel.js";
// import ProfileService from "@/module/Profile/service/ProfileService.js";
import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA.js";
import Account from "@/helper/AccountHelper.js";

export default {
    inject: ["AccountStore"],
    computed: {
        isLogin: function () {
            return this.AccountStore.state.isLogin;
        },
        mixinProfile: function () {
            return this.AccountStore.state.profile;
        },
    },
    data: function () {
        return {
            // consentInfo: new UserInfoModel(),
            isErr: false,
            token: Account.getToken(),

            consentTerms: null,
            termVersion: null,
            termLatestVer:null,

            consentPrivacy: null,
            privacyVersion: null,
            privacyLatestVer:null,
            necessaryCookies: null,

        };
    },
    created: function(){
        this.AccountStore.methods.loginStatus().subscribe(() => {
            if(this.isLogin){
                // console.log('this.modalController', this.modalController)
                this.checkPDPA();
                // this.checkConsentCookie();
            }
        });
    },
    methods: {
        onSetupModalCompleted: function () {
            this.initialPdpaModal();
        },
        checkPDPA: function(){
            this.loadingModal.show();
            return new Promise((resolve, reject) => {
                // const token = Account.getToken();
                BzbsPDPA.apiGetConsent(this.token)
                    .subscribe((data) => {
                        this.consentTerms = data.TermAndCondition;
                        this.consentPrivacy = data.DataPrivacy
                        this.necessaryCookies = data.NecessaryCookies;
                        // this.consentTerms = 0;
                        // this.consentPrivacy = 0;
                        this.getConsentVersion();
                        resolve(data);
                    }, (err) => {
                        this.loadingModal.hide();
                        this.errorApi(err);
                        reject(err);
                    });
            });
        },

        getConsentVersion: function(){
            return new Promise((resolve, reject) => {
                BzbsPDPA.apiGetPDPAVersion(this.token)
                    .subscribe((data) => {
                        this.loadingModal.hide();
                        this.termVersion = data.terms.current_version;
                        this.termLatestVer = data.terms.latest_version;

                        this.privacyVersion = data.privacy.current_version
                        this.privacyLatestVer = data.privacy.latest_version

                        if (this.consentTerms < this.termVersion) {
                            this.modalController.pdpaModal.setTitle(this.lbl.sidemenu.term_cond)
                                    .setType('terms')
                                    .changeToConfirmBtn(true)
                                    .show();

                            //set action for onClickConfirm
                            this.modalController.pdpaModal.onClickAccept((data) => {
                                console.log(data)

                                if(this.consentPrivacy != this.privacyVersion) {
                                     //set action for onClickCancel
                                    // this.modalController.pdpaModal.hide();

                                    this.modalController.pdpaModal
                                        .clearModal()
                                        .setTitle(this.lbl.sidemenu.data_privacy)
                                        .setType('privacy')
                                        .changeToConfirmBtn(true)
                                        .show();

                                    this.modalController.pdpaModal.onClickAccept((data) => {
                                        console.log(data)
                                        return new Promise((resolve, reject) => {
                                            BzbsPDPA.apiPostConsent(this.token, this.termVersion, this.privacyVersion)
                                                .subscribe((data) => {
                                                    this.checkConsentCookie();
                                                    this.modalController.pdpaModal.hide();
                                                    resolve(data);

                                                }, (err) => {
                                                    this.loadingModal.hide();
                                                    this.errorApi(err);
                                                    reject(err);
                                                });
                                        });
                                    });
                                } else {
                                    return new Promise((resolve, reject) => {
                                        BzbsPDPA.apiPostConsent(this.token, this.termVersion, this.privacyVersion)
                                            .subscribe((data) => {

                                                this.modalController.pdpaModal.hide();
                                                this.checkConsentCookie();
                                                resolve(data);

                                            }, (err) => {
                                                this.loadingModal.hide();
                                                this.errorApi(err);
                                                reject(err);
                                            });
                                    });
                                }
                            });

                            //set action for onClickCancel
                            // this.modalController.pdpaModal.onClickCancelTerm(() => {
                            //     this.modalController.pdpaModal.hide();
                            //     location.reload();
                            // });

                        } else if (this.consentPrivacy < this.privacyVersion) {
                            this.modalController.pdpaModal.setTitle(this.lbl.sidemenu.data_privacy)
                                .setType('privacy')
                                .changeToConfirmBtn(true)
                                .show();

                            this.modalController.pdpaModal.onClickAccept((data) => {
                                console.log(data)
                                return new Promise((resolve, reject) => {
                                    BzbsPDPA.apiPostConsent(this.token, this.termLatestVer, this.privacyLatestVer)
                                        .subscribe((data) => {

                                            this.checkConsentCookie();
                                            this.modalController.pdpaModal.hide();
                                            resolve(data);

                                        }, (err) => {
                                            this.loadingModal.hide();
                                            this.errorApi(err);
                                            reject(err);
                                        });
                                });
                            });

                        } else {

                            this.checkConsentCookie();
                            // this.redirectLogin();
                            resolve(data);
                        }

                    }, (err) => {
                        this.loadingModal.hide();
                        this.errorApi(err);
                        reject(err);
                    });
            });
        },
        checkConsentCookie: function () {
            // this.necessaryCookies = null;
            if (!this.necessaryCookies) {

                this.modalController.cookieModal.show();
                this.modalController.cookieModal.onClickOk(() => {
                    this.saveCookie();
                });
                // this.modalController.cookieModal.onclickOk(() => {
                //     this.saveCookie();
                // });

                this.modalController.cookieModal.onClickOpenPdpa(() => {

                    this.modalController.pdpaModal
                        .clearModal()
                        .setTitle(this.lbl.sidemenu.data_privacy)
                        .setType('privacy')
                        .changeToConfirmBtn(true)
                        .show();
                    this.modalController.pdpaModal.onClickAccept(()=>{
                        this.saveCookie();
                    })
                });
            }
        },
        saveCookie: function () {
            var dataPrivacy = {
                necessaryCookies: 1,
            };
            return new Promise ((resolve,reject)=>{
                BzbsPDPA.apiPostConsent(this.token, this.termLatestVer, this.privacyLatestVer, dataPrivacy)
                .subscribe((data) => {
                    this.modalController.pdpaModal.hide();
                    resolve(data);

                }, (err) => {
                    this.loadingModal.hide();
                    this.errorApi(err);
                    reject(err);
                });
            })

        }
    },
}
